import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">
            <div className="privacy-card">
                <h1 className="privacy-title">Privacy Policy</h1>
                <p className="privacy-subtitle">Boat Track App</p>
                <p className="privacy-date">Effective Date: January 2026</p>

                <p className="privacy-text">
                    Boat Track App respects your privacy and is committed to protecting your
                    personal information. This Privacy Policy explains how we collect,
                    use, and protect your data when you use our mobile application.
                </p>

                <h3>1. Information We Collect</h3>
                <ul>
                    <li>Full Name</li>
                    <li>Email Address</li>
                </ul>

                <h3>2. How We Use Your Information</h3>
                <ul>
                    <li>To create and manage your account</li>
                    <li>To provide app functionality</li>
                    <li>To communicate important updates</li>
                </ul>

                <h3>3. Data Security</h3>
                <p className="privacy-text">
                    We use secure systems and technologies to protect your personal data
                    from unauthorized access.
                </p>

                <h3>4. Data Sharing</h3>
                <p className="privacy-text">
                    We do not sell, trade, or share your personal information with third parties.
                </p>

                <h3>5. Account Deletion</h3>
                <p className="privacy-text">
                    You can request account deletion anytime from the app or by contacting support.
                    Once deleted, your personal data will be permanently removed.
                </p>

                <h3>6. Your Rights</h3>
                <ul>
                    <li>Access your personal information</li>
                    <li>Request correction or deletion of your data</li>
                </ul>

                <h3>7. Contact Us</h3>
                <p className="privacy-text">
                    If you have any questions about this Privacy Policy, contact us at:
                </p>

                <p className="privacy-email">support@boattrackapp.com</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
